import { BaseService } from './base.service';

export default class AppContextService extends BaseService {
  public async getAppContext() {
    return this.axios.get(`${this.backendUrl}/app-context`);
  }
}
